import { useEffect } from "react";
import { http } from "../lib/api";
import { readPendingPayments, removePendingPayment, writePendingPayments } from "../lib/checkout";

export function usePaymentReturn(deviceId, setCredits, showToast) {
  useEffect(() => {
    if (!deviceId) return undefined;

    const params = new URLSearchParams(window.location.search);
    const checkoutId = params.get("session_id");
    if (checkoutId) {
      writePendingPayments([...readPendingPayments(), checkoutId]);
      window.history.replaceState({}, "", window.location.pathname);
    }

    let stopped = false;
    const activePolls = new Set();

    const pollSession = async (id, attempts = 0) => {
      if (stopped) return;
      if (attempts === 0 && activePolls.has(id)) return;
      activePolls.add(id);

      if (attempts >= 12) {
        activePolls.delete(id);
        removePendingPayment(id);
        showToast("Zahlungsstatus konnte nicht bestaetigt werden. Oeffne die App spaeter erneut.", "error");
        return;
      }

      try {
        const { data } = await http.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") {
          const dev = await http.get(`/device/${deviceId}`);
          setCredits({ standard: dev.data.standard_credits, pro: dev.data.pro_credits });
          removePendingPayment(id);
          activePolls.delete(id);
          showToast("Zahlung erfolgreich! Deine Anfragen wurden gutgeschrieben.", "success");
          return;
        }
        if (data.status === "expired") {
          removePendingPayment(id);
          activePolls.delete(id);
          showToast("Zahlung abgelaufen. Bitte erneut versuchen.", "error");
          return;
        }
      } catch (e) {
        console.warn("Zahlungsstatus-Abfrage fehlgeschlagen:", e);
      }

      setTimeout(() => pollSession(id, attempts + 1), 2500);
    };

    const checkPending = () => {
      const ids = readPendingPayments();
      if (ids.length === 0) return;
      showToast("Zahlung wird geprueft ...", "info");
      ids.forEach((id) => pollSession(id));
    };

    checkPending();
    window.addEventListener("focus", checkPending);
    window.addEventListener("pageshow", checkPending);
    const onVisibility = () => {
      if (document.visibilityState === "visible") checkPending();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      stopped = true;
      window.removeEventListener("focus", checkPending);
      window.removeEventListener("pageshow", checkPending);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [deviceId, setCredits, showToast]);
}
